<template>
  <div>
    <el-alert
      title="按工单编制每日各班次计划产量（草稿→批准）。与「班次产量汇总」实际报工分开。"
      type="info"
      :closable="false"
      show-icon
      style="margin-bottom:12px"
    />
    <div class="toolbar">
      <el-input v-model="query.ppsCode" clearable placeholder="单号" style="width:160px" @keyup.enter.native="search" />
      <el-input v-model="query.orderCode" clearable placeholder="工单号" style="width:160px" @keyup.enter.native="search" />
      <el-select v-model="query.ppsState" clearable placeholder="状态" style="width:110px">
        <el-option label="草稿" value="00" />
        <el-option label="已批准" value="01" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新建</el-button>
    </div>

    <el-table :data="list" border v-loading="loading">
      <el-table-column type="index" label="序号" width="60" align="center" :index="indexMethod" />
      <el-table-column prop="ppsCode" label="单号" width="180" />
      <el-table-column prop="orderCode" label="工单号" width="140" />
      <el-table-column prop="orderName" label="工单名称" min-width="160" show-overflow-tooltip />
      <el-table-column label="状态" width="90" align="center">
        <template slot-scope="{ row }">
          <el-tag size="mini" :type="row.ppsState === '01' ? 'success' : 'info'">
            {{ row.ppsState === '01' ? '已批准' : '草稿' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" min-width="120" show-overflow-tooltip />
      <el-table-column label="操作" width="240" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openEdit(row.ppsId, true)">查看</el-button>
          <el-button v-if="row.ppsState === '00'" type="text" @click="openEdit(row.ppsId)">修改</el-button>
          <el-button v-if="row.ppsState === '00'" type="text" @click="doAccept(row)">批准</el-button>
          <el-button v-if="row.ppsState === '00'" type="text" style="color:#ef4444" @click="doDelete(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="total" :page="page" :page-size="pageSize" :page-sizes="[10, 20, 50, 100]"
      @current-change="onPage" @size-change="onSize"
    />

    <el-dialog :title="dialogTitle" :visible.sync="visible" width="980px" :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" label-width="90px" :disabled="readonly">
        <el-row :gutter="12">
          <el-col :span="8">
            <el-form-item label="单号"><el-input v-model="form.ppsCode" placeholder="留空自动生成" /></el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="工单" prop="orderId">
              <el-select v-model="form.orderId" filterable style="width:100%" @change="onOrderChange">
                <el-option
                  v-for="o in orderOptions"
                  :key="o.orderId"
                  :label="(o.orderCode || '') + ' / ' + (o.orderName || '')"
                  :value="o.orderId"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="备注"><el-input v-model="form.remark" /></el-form-item>
          </el-col>
        </el-row>
        <div style="margin:8px 0" v-if="!readonly">
          <el-button type="primary" size="mini" @click="addLine">添加行</el-button>
        </div>
        <el-table :data="form.lineList" border size="small">
          <el-table-column label="计划日期" width="150">
            <template slot-scope="s">
              <el-date-picker v-model="s.row.planDate" type="date" value-format="yyyy-MM-dd" size="mini" style="width:100%" :disabled="readonly" />
            </template>
          </el-table-column>
          <el-table-column label="班次" width="140">
            <template slot-scope="s">
              <el-select v-model="s.row.shiftId" filterable size="mini" style="width:100%" :disabled="readonly">
                <el-option v-for="sh in shiftOptions" :key="sh.shiftId" :label="sh.shiftName" :value="sh.shiftId" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="工序任务(可选)" min-width="160">
            <template slot-scope="s">
              <el-select v-model="s.row.taskId" filterable clearable size="mini" style="width:100%" :disabled="readonly">
                <el-option v-for="t in taskOptions" :key="t.taskId" :label="t.taskCode" :value="t.taskId" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="计划数量" width="130">
            <template slot-scope="s">
              <el-input-number v-model="s.row.plannedQty" :min="0" :precision="3" size="mini" style="width:100%" :disabled="readonly" />
            </template>
          </el-table-column>
          <el-table-column v-if="!readonly" label="操作" width="70" align="center">
            <template slot-scope="s">
              <el-button type="text" size="mini" @click="form.lineList.splice(s.$index, 1)">删</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <div slot="footer">
        <el-button @click="visible = false">{{ readonly ? '关闭' : '取消' }}</el-button>
        <el-button v-if="!readonly" type="primary" :loading="saving" @click="submit">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import {
  listProductionPerShift, getProductionPerShift, saveProductionPerShift,
  updateProductionPerShift, deleteProductionPerShift, acceptProductionPerShift
} from '../../api/productionPerShift'
import { selectProductionOrder } from '../../api/productionOrder'
import { selectOrderTask } from '../../api/orderTask'
import { selectShift } from '../../api/shift'

function emptyForm() {
  return { ppsId: '', ppsCode: '', orderId: '', remark: '', lineList: [] }
}

export default {
  name: 'ProductionPerShiftPage',
  components: { ListPagination },
  data() {
    return {
      query: { ppsCode: '', orderCode: '', ppsState: '' },
      list: [], total: 0, page: 1, pageSize: 20, loading: false,
      visible: false, readonly: false, saving: false, form: emptyForm(),
      rules: { orderId: [{ required: true, message: '请选择工单', trigger: 'change' }] },
      orderOptions: [], shiftOptions: [], taskOptions: []
    }
  },
  computed: {
    dialogTitle() {
      if (this.readonly) return '查看每班产量计划'
      return this.form.ppsId ? '修改每班产量计划' : '新建每班产量计划'
    }
  },
  created() {
    selectProductionOrder().then(res => { this.orderOptions = res.data || [] }).catch(() => {})
    selectShift().then(res => { this.shiftOptions = res.data || [] }).catch(() => {})
    this.load()
  },
  methods: {
    indexMethod(i) { return (this.page - 1) * this.pageSize + i + 1 },
    search() { this.page = 1; this.load() },
    onPage(p) { this.page = p; this.load() },
    onSize(s) { this.pageSize = s; this.page = 1; this.load() },
    load() {
      this.loading = true
      listProductionPerShift({
        currentPage: this.page, pageSize: this.pageSize,
        ppsCode: this.query.ppsCode, orderCode: this.query.orderCode, ppsState: this.query.ppsState
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    openEdit(id, readonly) {
      this.readonly = !!readonly
      this.form = emptyForm()
      this.taskOptions = []
      this.visible = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
      if (!id) { this.addLine(); return }
      getProductionPerShift(id).then(res => {
        this.form = Object.assign(emptyForm(), res.data || {})
        if (!this.form.lineList) this.form.lineList = []
        if (this.form.orderId) this.loadTasks(this.form.orderId)
      })
    },
    onOrderChange(orderId) {
      this.loadTasks(orderId)
      ;(this.form.lineList || []).forEach(l => { l.taskId = '' })
    },
    loadTasks(orderId) {
      if (!orderId) { this.taskOptions = []; return }
      selectOrderTask(orderId).then(res => { this.taskOptions = res.data || [] }).catch(() => { this.taskOptions = [] })
    },
    addLine() {
      if (!this.form.lineList) this.form.lineList = []
      this.form.lineList.push({ planDate: '', shiftId: '', taskId: '', plannedQty: 0 })
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        if (!(this.form.lineList || []).length) {
          this.$message.warning('请添加明细')
          return
        }
        this.saving = true
        const req = this.form.ppsId ? updateProductionPerShift(this.form) : saveProductionPerShift(this.form)
        req.then(() => {
          this.$message.success('保存成功')
          this.visible = false
          this.load()
        }).finally(() => { this.saving = false })
      })
    },
    doAccept(row) {
      this.$confirm('批准后不可再改，继续？', '提示', { type: 'warning' }).then(() => {
        acceptProductionPerShift(row.ppsId).then(() => {
          this.$message.success('已批准')
          this.load()
        })
      }).catch(() => {})
    },
    doDelete(row) {
      this.$confirm('确定删除？', '提示', { type: 'warning' }).then(() => {
        deleteProductionPerShift([row.ppsId]).then(() => {
          this.$message.success('已删除')
          this.load()
        })
      }).catch(() => {})
    }
  }
}
</script>
